import http from '@/service/http'

const fetchOne = async (context, url) => {
  const response = await http.get(url)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }, {url, action}) => {
  const response = await http.get(url)
  if (response !== null) {
    commit(action, response.data.data)
    return Promise.resolve(response.data.data)
  }
}

const save = async (context, obj) => {
  const { verb, url, entity } = obj
  const response = await http[verb](url, entity)

  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const update = ({ commit, state }, {mutation, obj}) => {
  commit(mutation, obj)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/curriculo-anotacoes/${id}`)
    const message = response.data.data
    // const index = findIndex(state.list, { id })

    // if (index > -1) {
    //   commit('REMOVE_ONE', { index })
    // }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/vp/curriculo/minhasAnotacoes/store/actions.js